import type { Formula } from "building-types/options/formula";
import type { OptionChoices } from "building-types/options/optionChoices";
import { Parser, type Expression, type Value } from "expr-eval";

const parser = new Parser({
  allowMemberAccess: false,
  operators: {
    add: true,
    divide: true,
    multiply: true,
    subtract: true,
    logical: true,
    comparison: true,

    power: false,
    remainder: false,
    concatenate: false,
    conditional: false,
    factorial: false,
    in: false,
    assignment: false,
  },
});

const formulaExpCache: { [formula: string]: Expression } = {};

export function parseFormula(formula: string): Expression {
  if (formulaExpCache[formula]) {
    return formulaExpCache[formula];
  }
  return (formulaExpCache[formula] = parseFormulaNoCache(formula));
}

export function formulaGetIdentifiers(formula: Formula | undefined): string[] {
  if (!formula) {
    return [];
  }

  const e = parseFormula(formula.formula);
  return e.symbols();
}

function parseFormulaNoCache(formula: string): Expression {
  return parser.parse(formula);
}

export function isFormula(v: any): v is Formula {
  return !!v && typeof v === "object" && Object.hasOwn(v, "type") && v.type === "FORMULA";
}

/**
 * @deprecated
 *
 * Cast to a non-nullable type to make expression evaluation happy. The library doesn't
 * explicitly handle nulls, but it looks like it should behave as javascript does with
 * nulls, where it has predictable results and doesn't crash.
 *
 * Ref: https://github.com/silentmatt/expr-eval/blob/master/src/evaluate.js
 */
export function castOptionChoicesToExpressionValue(optionChoices: OptionChoices): Value {
  return optionChoices as Value;
}
